import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { MatchingAnswer, MatchingAnswerItem } from "./matching-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

@injectable()
export class MatchingQuestionAnswerProtobufSerializer
  implements Api.StateSerializationPlugin<MatchingAnswer> {
  key = {
    id: 14,
    name: { ns: "suspend-data", name: "question-answer-matching" },
    format: "protobuf"
  };

  serialize(data: MatchingAnswer): Result<Uint8Array, Api.SerializerError> {
    const message = new MatchingAnswerProtoMessage({
      pairs: data.pairs.map(pair => new MatchingAnswerItemProtoMessage(pair)),
      pairsOrder: data.pairsOrder,
    });

    return ProtobufSerializer.serialize<MatchingAnswerProtoMessage>(
      message,
      MatchingAnswerProtoMessage
    );
  }

  deserialize(
    content: Uint8Array
  ): Result<MatchingAnswer, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<
      MatchingAnswerProtoMessage
    >(content, MatchingAnswerProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const message = deserializeResult.value;
    const result: MatchingAnswer = {
      pairs: message.pairs.map(protoItem => ({
        conceptId: protoItem.conceptId,
        definitionId: protoItem.definitionId,
        connected: protoItem.connected,
      })),
      pairsOrder: message.pairsOrder,
    };

    return ok(result);
  }
}

@Type.d("MatchingAnswerItemProtoMessage")
export class MatchingAnswerItemProtoMessage extends Message<MatchingAnswerItemProtoMessage> {
  @Field.d(1, "string", "optional", "")
  conceptId: string;

  @Field.d(2, "string", "optional", "")
  definitionId: string;

  @Field.d(3, "bool", "optional", false)
  connected: boolean;
}

@Type.d("MatchingAnswerProtoMessage")
class MatchingAnswerProtoMessage extends Message<MatchingAnswerProtoMessage> {
  @Field.d(1, MatchingAnswerItemProtoMessage, "repeated")
  pairs: MatchingAnswerItem[];

  @Field.d(2, "string", "repeated")
  pairsOrder: string[];
}
